var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid--container"},[_c('div',{staticClass:"row"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"referral-code":_vm.referralCode,"invite-token":_vm.inviteToken,"org-id":_vm.orgId}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }